import { render, staticRenderFns } from "./Weddinganimation.vue?vue&type=template&id=27e4cc5e&"
import script from "./Weddinganimation.vue?vue&type=script&lang=js&"
export * from "./Weddinganimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports